<template>
  <div class="map-share-side-panel modern-glass-toolbar">
    <div class="panel-header d-flex justify-space-between align-center px-3 py-2">
      <span class="font-weight-bold" style="color: #475569; font-size: 16px;">{{ title }}</span>
      <v-btn icon small @click="$emit('close')">
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </div>
    <v-divider></v-divider>
    <div class="panel-body flex-grow-1 overflow-auto">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MapShareSidePanel',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.map-share-side-panel {
  position: absolute;
  top: 96px;
  left: 88px;
  width: 320px;
  height: calc(100vh - 120px);
  max-height: 700px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  z-index: 100;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
}

.panel-header {
  background: transparent;
}

.panel-body {
  position: relative;
  width: 100%;
}
</style>
